import BookForm from "./BookForm";

export default function NewBookPage() {
  return <BookForm mode="create" />;
}
